import React from 'react';
import { useLastCeebMeta } from '../hooks/useLastCeebMeta';
import CeebBotReport from './CeebBotReport';

interface Props {
  inspectionId: string;
}

/**
 * CeebLastRunReport — samodzielny mount raportu bota CEEB w sekcji CEEB budynku
 * (issue #51b — follow-up #51/B7: raport istniał, ale nie był wpięty w żywe UI).
 *
 * Wzorzec jak CeebPhaseAPanel / CeebDemoButton („Samodzielny (…), żeby dotyk
 * BuildingInspectionView był minimalny"): sam pobiera GET last-meta.json (hook
 * useLastCeebMeta) i renderuje CeebBotReport TYLKO gdy ostatni run bota — z „Wyślij do
 * CEEB" w PipelineView ALBO z demo — dotyczy WŁAŚNIE tego przeglądu. Bez dopasowania
 * (inny przegląd / brak run-a) nie renderuje nic, żeby nie pokazać wyniku innego budynku.
 */
const CeebLastRunReport: React.FC<Props> = ({ inspectionId }) => {
  const { meta } = useLastCeebMeta(inspectionId);
  if (!meta) return null;
  return <CeebBotReport meta={meta} />;
};

export default CeebLastRunReport;
